import React from 'react';
import PropTypes from 'prop-types';
import {HorizontalListString} from '../HorizontalList';

const Affinities = ({heading, items}) => {
    if (!heading || items.length === 0) {
        return null;
    }

    return (
        <div>
            <strong>{heading}</strong> <HorizontalListString items={items} />
        </div>
    );
};

Affinities.propTypes = {
    heading: PropTypes.string,
    items: PropTypes.arrayOf(PropTypes.string),
};

Affinities.defaultProps = {
    heading: '',
    items: [],
};

export default Affinities;
